<template>
  <div class="sub-page">
    <div class="title">
      <div>代表团报名</div>
    </div>
      <div class="main">
        <a-spin :spinning="baseDataLoading">
          <div class="team">
            <div class="team_title">代表团基本信息</div>
            <div class="team_container" v-if="team.baseData">
              <div style="width: 100px; height: 100px;margin-bottom: 10px">
                <img :src="team.baseData.unitLogo" style="width: 98px; height: 98px;"/>
              </div>
              <div style="font-size: 16px;">{{ team.baseData.unitName }}<a-icon @click="$refs.teamForm.show(team.baseData)" type="edit" :style="{ color: 'gray', marginLeft: '5px', cursor: 'pointer', fontSize: '16px' }"/></div>
            </div>
            <div v-if="!team.baseData" style="min-height: 350px;">
              <a-empty >
                <span slot="description" style="color: gray;">您还未创建代表团信息</span>
                <a-button type="primary" size="small" @click="$refs.teamForm.show()">点击创建</a-button>
              </a-empty>
            </div>
          </div>
        </a-spin>
        <div v-if="team.baseData" style="width: 100%;overflow: hidden;">
          <div class="list clearFloat" style="line-height: 45px;">
            <div class="title" style="margin-bottom:20px;">
              注：成年组的报项，请在需要参加的项目前划√
            </div>
            <a-checkbox-group v-model="checkProgram" @change="changeBool">
              <a-row>
                <a-col :span="6" v-for="(item,index) in programList" :key="index" style="margin-bottom:10px;">
                  <a-checkbox :value="item.id">
                    {{ item.name }}
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>
          </div>
          <!-- <div style="overflow: hidden;margin-bottom:30px;">
            <h3>代表团名单</h3>
            <div v-for="(item,index) in nameList" :key="index" style="width: 100%;overflow: hidden;margin-bottom:20px;border-bottom:1px solid #eee;padding-bottom:20px;">
              <span style="float:left;line-height: 30px;padding-right: 10px;"><b>{{ index + 1 }}.</b></span>
              <a-select v-model="item.type" style="width: 120px;float:left;margin-right:20px;">
                <a-select-option value="团长">
                  团长
                </a-select-option>
                <a-select-option value="副团长">
                  副团长
                </a-select-option>
                <a-select-option value="联络员">
                  联络员
                </a-select-option>
                <a-select-option value="其他">
                  其他
                </a-select-option>
              </a-select>
              <a-input v-model="item.name" placeholder="姓名" style="width: 120px;float:left;margin-right:20px;"/>
              <a-radio-group v-model="item.sex" style="width: 120px;float:left;margin-right:20px;">
                <a-radio :value="1">
                  男
                </a-radio>
                <a-radio :value="2">
                  女
                </a-radio>
              </a-radio-group>
              <a-input v-model="item.duties" placeholder="单位及职务" style="width: 220px;float:left;margin-right:20px;"/>
              <a-input v-model="item.mobile" placeholder="联系电话" style="width: 220px;float:left;margin-right:20px;"/>
              <a-icon type="delete" style="color:red;margin-right:20px;" @click="delName(index)" v-if="nameList.length > 1"/>
              <a-icon type="plus-circle" @click="addName" v-if="index === nameList.length - 1"/>
            </div>
          </div> -->
          <div style="text-align: center;">
            <a-button @click="submit" type="primary">
              提交报项信息
            </a-button>
          </div>
        </div>
        <a-spin :spinning="projectLoading">
          <div class="project" v-if="team.baseData">
            <div class="project_title">授权参赛项目给报名负责人</div>
            <div class="project_container">
              <a-collapse v-model="activeKey">
                <a-collapse-panel v-for="(item, index) in team.group" :key="index + ''">
                  <div slot="header" class="panel_header">
                    <div class="group_name">{{ item.name }}</div>
                    <div>已选项目：{{ item.choiced.length }}个</div>
                  </div>
                  <div class="panel_content">
                    <div class="panel_p_choiced">
                      <div class="p_item" v-for="(cItem, cIndex) in item.choiced" :key="cIndex" v-show="cItem['show'] != false" :style="{marginRight:cIndex%3==2?'':'28px'}">
                        <div class="choiced_title">
                          <div class="choiced_header">
                            <div>{{ cItem.programName }}</div>
                            <div>
                              <a-button size="small" type="primary" icon="check" @click="addUser(item, index, cItem, cIndex)" v-if="!cItem.id">提交</a-button>
                              <a-button size="small" icon="delete" @click="delUser(item, index, cItem, cIndex)">删除</a-button>
                            </div>
                          </div>
                          <div>{{ cItem.title }}</div>
                        </div>

                        <div class="choiced_form">
                          <div class="form_label">负责人姓名：</div>
                          <div class="form_input"><a-input type="text" v-model="cItem.name" :disabled="!!cItem.id"/></div>
                        </div>
                        <div class="choiced_form">
                          <div class="form_label">报名登录账号：</div>
                          <div class="form_input"><a-input type="text" v-model="cItem.account" :disabled="!!cItem.id"/></div>
                        </div>
                        <div class="choiced_form">
                          <div class="form_label">报名登录密码：</div>
                          <div class="form_input"><a-input-password v-model="cItem.pwd"/></div>
                        </div>
                      </div>
                    </div>
                    <div class="panel_p_programs">
                      <div v-for="(p, pIndex) in item.programs" :key="pIndex" class="panel_p_programs-item" :style="{marginRight:pIndex%3==2?'':'28px'}">
                        <a-checkbox :checked="programCheckedStatus(item, p)" :value="p.matchId" @change="programChange(item, p, $event)">{{ p.name }}<br/>{{ p.title }}</a-checkbox>
                      </div>
                    </div>
                  </div>
                </a-collapse-panel>
              </a-collapse>
            </div>
          </div>
        </a-spin>

        <!-- 授权项目 -->
        <a-spin :spinning="empowerProjectLoading">
          <div class="project" v-if="empowerProjects && empowerProjects.length > 0">
            <div class="project_title">授权项目</div>
            <div v-for="(item, index) in empowerProjects" :key="index">
              <div class="project_title" style="font-size: 18px">{{ item.unitName }}</div>
              <div class="project_container">
                <a-collapse v-model="activeKey">
                  <a-collapse-panel v-for="(group, gIndex) in item.groupList" :key="gIndex + ''">
                    <div slot="header" class="panel_header">
                      <div class="group_name">{{ group.name }}</div>
                      <div>授权项目：{{ group.choiced.length }}个</div>
                    </div>
                    <div class="panel_content">
                      <div style="display: flex; flex-wrap: wrap">
                        <div v-for="(cItem, cIndex) in group.choiced" :key="cIndex" class="choiced_project">
                          <div style="font-weight: 600">{{ cItem.programName }}</div>
                          <div>{{ cItem.title }}</div>
                        </div>
                      </div>
                    </div>
                  </a-collapse-panel>
                </a-collapse>
              </div>
            </div>
          </div>
        </a-spin>
      </div>
    <team-form ref="teamForm" @success="delegationSelfAgency()"></team-form>
  </div>
</template>

<script>
import UploadFile from '../../../../comm/upload/UploadFile'
import TeamForm from './modal/TeamForm'
export default {
  name: 'DelegationSignup',
  props: {
  },
  components: {UploadFile, TeamForm},
  data () {
    return {
      baseDataLoading: false,
      projectLoading: false,
      empowerProjectLoading: false,
      activeKey: ['0'],
      team: {
        baseData: null,
        group: null
      },
      checkProgram: [],
      programList: [],
      empowerProjects: null,
      nameList:[{
        type: '团长',
        name: '',
        sex: 1,
        duties: '',
        mobile: ''
      }]
    }
  },
  mounted () {
    this.delegationSelfAgency()
    this.delegationTeamJoinGroupSub()
    this.findProgram()
  },
  methods: {
    findProgram () {
      this.$api.district.querySportsProgram().then(res => {
        if (res.status === 0) {
          this.programList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    findDelegation () {
      this.$api.district.queryDelegation({matchId: this.matchId, agencyId: this.team.baseData.agencyId}).then(res => {
        if (res.status === 0) {
          this.checkProgram = res.data !== null ? JSON.parse(res.data.program) : []
          this.$forceUpdate()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    findDelegationName () {
      this.$api.district.queryDelegationName({matchId: this.matchId, agencyId: this.team.baseData.agencyId}).then(res => {
        if (res.status === 0) {
          if (res.data !== null) {
            this.nameList = JSON.parse(res.data.dataName)
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    addName () {
      this.nameList.push({
        type: '团长',
        name: '',
        sex: 1,
        duties: '',
        mobile: ''
      })
    },
    delName (index) {
      this.nameList.splice(index, 1)
    },
    programCheckedStatus (group, program) {
      let result = group.choiced.filter(v => v.matchId == program.matchId)
      console.log(result.length > 0 && result[0]['show'] != false)
      return result.length > 0 && result[0]['show'] != false
    },
    programChange (group, p, e) {
      const checked = e.target.checked
      // 获取匹配的项目
      let matchChecked = group.choiced.filter(v => v.matchId == p.matchId)
      if (checked) {
        if (matchChecked.length > 0) {
          matchChecked[0]['show'] = true
        } else {
          group.choiced.push({ id: null, matchId: p.matchId, programName: p.name, title: p.title, name: null, account: null, pwd: null })
        }
        
      }
      this.$forceUpdate()
    },
    changeBool (e) {
      this.checkProgram = e
      console.log(this.checkProgram)
    },
    submit () {
      // let err = ''
      // this.nameList.forEach(element => {
      //   if (element.name === '' || element.duties === '' || element.mobile === '') {
      //     err = '请将代表团名单填写完整'
      //   }
      // })
      // if (err !== '') {
      //   this.$message.error(err)
      //   return
      // } else {
      //   let valData = {
      //     matchId: this.matchId,
      //     agencyId: this.team.baseData.agencyId,
      //     dataName: JSON.stringify(this.nameList)
      //   }
      //   this.$api.district.joinDelegationName(valData).then(res => {
      //     if (res.status === 0) {
      //       this.$message.success('代表团名单提交成功')
      //     } else {
      //       this.$message.error(res.msg)
      //     }
      //   }).catch(err => {
      //     console.log(err)
      //   })
      // }
      let valData1 = {
        matchId: this.matchId,
        agencyId: this.team.baseData.agencyId,
        dataName: '[]'
      }
      this.$api.district.joinDelegationName(valData1).then(res => {
        if (res.status === 0) {
          // this.$message.success('代表团名单提交成功')
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
      let valData = {
        matchId: this.matchId,
        agencyId: this.team.baseData.agencyId,
        program: this.checkProgram.length > 0 ? JSON.stringify(this.checkProgram) : '[]'
      }
      this.$api.district.joinDelegation(valData).then(res => {
        if (res.status === 0) {
          this.$message.success('成年组报项保存成功')
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    delegationSelfAgency () {
      this.baseDataLoading = true
      this.$api.district.delegationSelfAgency().then(res => {
        if (res.status == 0) {
          this.team.baseData = res.data
          this.delegationTeamJoinGroup()
          if (res.data !== null) {
            this.findDelegation()
            this.findDelegationName()
          }
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.baseDataLoading = false
      })
    },
    // 授权项目
    delegationTeamJoinGroupSub () {
      this.empowerProjectLoading = true
      this.$api.district.delegationTeamJoinGroupSub().then(res => {
        if (res.status === 0) {
          this.empowerProjects = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.empowerProjectLoading = false
      })
    },
    // 查询代表团授权项目人员
    delegationTeamJoinGroup () {
      if (this.team.baseData && this.team.baseData.agencyId) {
        this.projectLoading = true
        this.$api.district.delegationTeamJoinGroup(this.team.baseData.agencyId).then(res => {
          if (res.status === 0) {
            this.team.group = res.data
          } else {
            this.$message.error(res.msg)
          }
        }).finally(() => {
          this.projectLoading = false
        })
      }
    },
    addUser (group, groupIndex, choiced, choicedIndex) {
      if (!choiced.name) {
        this.$message.error('请输入负责人姓名')
        return
      }
      if (!choiced.account) {
        this.$message.error('请输入负责人登录账号')
        return
      }
      if (!choiced.pwd) {
        this.$message.error('请输入负责人登录密码')
        return
      }
      const params = {
        matchId: choiced.matchId,
        agencyId: this.team.baseData.agencyId,
        seriesId: this.$api.district.matchId,
        groupId: group.groupId,
        name: choiced.name,
        mobile: choiced.account,
        pwd: choiced.pwd
      }
      this.projectLoading = true
      this.$api.district.delegationAddUser(params).then(res => {
        if (res.status === 0) {
          this.$message.success('添加成功')
          this.team.group[groupIndex].choiced[choicedIndex].id = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.projectLoading = false
      })
    },
    delUser (group, groupIndex, choiced, choicedIndex) {
      if (!choiced.id) {
        choiced['show'] = false
        this.$forceUpdate()
        return
      }
      const that = this
      this.$confirm({
        title: '提示',
        content: '确认删除该负责人信息？',
        onOk () {
          that.projectLoading = true
          that.$api.district.delegationDelUser(choiced.id).then(res => {
            if (res.status === 0) {
              that.$message.success('删除成功')
              that.team.group[groupIndex].choiced.splice(choicedIndex, 1)
              that.$forceUpdate()
            } else {
              that.$message.error(res.msg)
            }
          }).finally(() => {
            that.projectLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.sub-page{
  width: 100%;
  margin-top:100px;
  background: #fbfbfb;
  .title {
    font-size: 21px;
    font-weight: 600;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e4e4e4;
    background: white;
    div {
      width: 1200px;
      margin: 30px auto;
    }
  }
  .main{
    width: 1200px;
    margin: 0 auto 30px;
    .team {
      margin-top: 20px;
      .team_title {
        font-size: 19px;
        font-weight: 600;
        padding-left: 30px;
      }
      .team_container {
        background: white;
        padding: 20px;
        border-radius: 10px;
        box-shadow: 0px 0px 3px 1px #e4e4e4;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 10px;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        input {
          border: 1px solid #e4e4e4;
          height: 44px;
          width: 429px;
          padding-left: 10px;
          padding-right: 10px;
        }
      }
    }
    .project {
      margin-top: 20px;
      .project_title {
        font-size: 19px;
        font-weight: 600;
        padding-left: 30px;
      }
      .project_container {
        background: white;
        border-radius: 10px;
        box-shadow: 0px 0px 3px 1px #e4e4e4;
        margin-top: 10px;
        margin-bottom: 10px;
        .panel_header {
          display: flex;
          align-items: end;
          padding-bottom: 10px;
          padding-top: 10px;
          cursor: pointer;
          .group_name {
            font-size: 18px;
            font-weight: 600;
            margin-right: 20px;
          }
        }
        .panel_content {
          transition: max-height .3s;
          overflow: hidden;
          margin-top: 10px;
          .panel_p_choiced {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            .p_item {
              padding: 20px;
              width: 370px;
              background: #F1F1F1;
              // margin-right: 10px;
              margin-bottom: 30px;
              border-radius: 10px;
              box-sizing: border-box;
              .choiced_title {
                border-bottom: 1px solid white;
                padding-bottom: 10px;
                .choiced_header {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                }
                .choiced_header:first-child {
                  font-size: 16px;
                  font-weight: 600;
                }
              }
              .choiced_form {
                display: flex;
                align-items: center;
                margin-top: 10px;
                .form_label {
                  font-size: 14px;
                  width: 100px;
                  text-align: left;
                }
                .form_input {
                  flex: 1;
                  input {
                    width: 100%;
                  }
                }
              }

            }
            .p_item:last-child{
              margin-right: auto;
            }
          }
          .panel_p_programs {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content:flex-start;
            .panel_p_programs-item{
              width: 370px;
              margin-bottom: 30px;
              background: #F1F1F1;
              border-radius: 10px;
              white-space: pre-wrap;
              box-sizing: border-box;
              padding: 20px;
              display: flex;
            }
          }
          .panel_p_programs:last-child{
            margin-right: auto !important;
          }
          .choiced_project {
            padding: 20px;
            min-width: 175px;
            background: #F1F1F1;
            margin-right: 10px;
            margin-bottom: 10px;
            border-radius: 10px;
          }
        }
      }
    }
  }

  .ant-collapse /deep/ {
    border: 0px;
    background: white;
    border-radius: 10px;
  }
  .ant-collapse /deep/ .ant-collapse-item {
    border-top: 0px;
  }
  .ant-collapse-item /deep/ {
    border-bottom: 1px solid #e4e4e4;
  }

  .ant-collapse-item /deep/.ant-collapse-content{
    border-top: 1px solid #e4e4e4;
  }
}
</style>



// WEBPACK FOOTER //
// src/district/views/delegation/components/DelegationSignup.vue